module.exports = __webpack_public_path__ + "static/media/icone_gorro_natal.dafe780d.png";